import { PageHeader } from '../components/ui/PageHeader.tsx';
import { Link } from 'react-router';
import type { Control } from '../lib/api.ts';
import { useGridQuery, useGridState } from '../lib/grid.ts';
import { DataTable, type Column } from '../components/DataTable.tsx';
import { Badge } from '../components/ui/Button.tsx';

const cycleLabel: Record<string, string> = { none: '—', monthly: '월', quarterly: '분기', semiannual: '반기', annual: '연' };
type Row = Control & { frameworkCode: string; scope: 'global' | 'tenant' };

const columns: Column<Row>[] = [
  { key: 'frameworkId', label: '프레임워크', width: '9rem', filter: 'select', render: (c) => c.frameworkCode },
  { key: 'groupCode', label: '분류', row: 2, span: 2, filter: 'text', render: (c) => c.groupCode ? `${c.groupCode} ${c.groupTitle ?? ''}` : '' },
  { key: 'code', label: '코드', width: '7rem', filter: 'text', render: (c) => <span className="font-mono text-[12px]">{c.code}</span> },
  { key: 'title', label: '제목', filter: 'text', render: (c) => <><Link className="text-accent-strong hover:underline" to={`/controls/${c.id}`}>{c.title}</Link>{c.scope === 'tenant' && <span className="ml-1"><Badge tone="info">커스텀</Badge></span>}</> },
  { key: 'scope', label: '구분', width: '5rem', filter: 'select', sortable: false, render: (c) => c.scope === 'tenant' ? '커스텀' : '글로벌' },
  { key: 'checkCycle', label: '점검주기', width: '6rem', filter: 'select', render: (c) => cycleLabel[c.checkCycle] },
  { key: 'policyReviewCycle', label: '규정검토', width: '6rem', filter: 'select', render: (c) => cycleLabel[c.policyReviewCycle] },
  { key: 'requirementText', label: '필요 증적', row: 2, span: 4, wrap: true, filter: 'text', sortable: false, render: (c) => <span className="text-[12px] text-slate-600">{c.requiredEvidenceTypes.join(', ')}</span> },
];

/** 통제항목 마스터 — 서버사이드 그리드 */
export function ControlsPage() {
  const { state, set } = useGridState('c', { sort: { col: 'orderNo', dir: 'asc' } });
  const data = useGridQuery<Row>('controls-grid', '/controls/grid', state);
  return (
    <div>
      <PageHeader title="통제항목 마스터" />
      {data.isError && <div className="text-red-600 text-sm mb-2">{(data.error as Error).message}</div>}
      <DataTable id="controls" columns={columns} data={data.data} state={state} onChange={set} isFetching={data.isFetching} />
    </div>
  );
}
